import { customAxios } from '../../../common/customAxios';

interface postImageSellTractorsProps {
  reqBody: {
    file: File;
  };
}

export const postImageSellTractors = ({ reqBody }: postImageSellTractorsProps): Promise<{ url: string }> => {
  return customAxios.post('/images/sell-tractors', reqBody, {
    headers: { 'Content-Type': 'multipart/form-data', charset: 'utf-8' },
  });
};
